import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDConfirmationDialog, FDListItem, FDListItemAvatar, FDListItemText,
} from '@facet-wealth/design';
import { useProfileImageChanged } from 'Hooks/useRefreshEvent';
import { dataAttrs, testAttr } from 'Helpers/Testing';

export const HouseholdMemberListItem = ({
  resource, onClick, selectedMember,
}) => {
  const [profileImageKey, setProfileImageKey] = React.useState(0);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  useProfileImageChanged(() => {
    setProfileImageKey(prev => prev + 1);
  });

  const onConfirm = async () => {
    await onClick(resource);
    setConfirmModalOpen(false);
  };

  const onClickMember = () => {
    // We need to check if the currently selected member has unsaved changes and if so
    // we show a confirmation dialog. This only really applies on desktop since
    // on mobile you are in a fullscreen modal anyway and it's not really possible to
    // navigate between household members without explicitly saving or canceling.
    if (!!selectedMember && selectedMember.isDirty()) {
      return setConfirmModalOpen(true);
    }
    return onConfirm();
  };

  return (
    <>
      <FDConfirmationDialog
        title={'You have unsaved changes'}
        message={'Are you sure you would like to proceed? If you click Confirm the changes on the selected household member will be lost.'}
        onClose={() => setConfirmModalOpen(false)}
        open={confirmModalOpen}
        onConfirm={onConfirm}
      />
      <FDListItem
        {...dataAttrs('household-member-list-item', resource, {
          [testAttr.dataFirstName]: resource.attr('firstName'),
          [testAttr.dataLastName]: resource.attr('lastName'),
        })}
        selected={resource.attr('isSelected') === 'true'}
        key={resource.id()}
        onClick={onClickMember}
      >
        {resource.withRelationship(fr.relationships.profileImage.name, (rel) => {
          return (
            <FDListItemAvatar
              key={profileImageKey}
              alt={resource.attr('fullName')}
              src={rel.link('related').url()}
            />
          );
        }, () => null)}
        <FDListItemText
          primaryText={resource.attr('fullName')}
        />
      </FDListItem>
    </>
  );
};

HouseholdMemberListItem.defaultProps = {
  onClick: null,
  selectedMember: null,
};

HouseholdMemberListItem.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onClick: PropTypes.func,
  selectedMember: PropTypes.object,
};
